import { ButtonPrimeReact, DropdownPrimeReact } from "@finanedi.es/storybook"
import { GetAllImpuestosDtoProps } from "api/DTOs/GetAllImpuestosDto"
import { useImpuestoEmpresaNew } from "api/ImpuestoEmpresa.hook"
import { GetAllImpuestosDtoIPagedEnumerableProps } from "api/Schemas/GetAllImpuestosDtoIPagedEnumerable"
import { TIPO_IMPUESTO_EMPRESA_ENUM } from "api/Types/TipoImpuestoEmpresaEnum"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { TYPES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { withFormik } from "formik"
import { InputNumber } from "primereact/inputnumber"
import { InputText } from "primereact/inputtext"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

interface UseImpuestosProps {
  impuestoEmpresa?: GetAllImpuestosDtoIPagedEnumerableProps
}

const DetalleArticuloDocument = ({
  handleSubmit,
  values,
  setFieldValue,
  onHide,
  isValid,
  librador,
  currency,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit: $TSMigrationFixMe
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: $TSMigrationFixMe
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
  onHide: () => void
  isValid: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  librador: $TSMigrationFixMe
  currency: string
}) => {
  const { t } = useTranslation()

  const { activeCompany } = useUsuarioEmpresaActiva()

  const { impuestoEmpresa }: UseImpuestosProps = useImpuestoEmpresaNew({
    EmpresaId: values?.empresaActiva?.id,
    TipoGrupoImpuesto: 0,
    TipoImpuestoEmpresa:
      activeCompany.nif === librador.nif
        ? TIPO_IMPUESTO_EMPRESA_ENUM.VENTA
        : TIPO_IMPUESTO_EMPRESA_ENUM.COMPRA,
    EsActivo: true,
    IsPagingEnabled: false,
  })

  const handlerChangeTaxe = ({ value }: { value: string }) => {
    setFieldValue("impuestoArticuloTipoId", value)
    setFieldValue(
      "impuestoArticuloPorcentaje",
      impuestoEmpresa?.items?.find(
        (impuesto: GetAllImpuestosDtoProps) => impuesto.id === value
      )?.valor
    )
    setFieldValue(
      "impuestoNombre",
      impuestoEmpresa?.items?.find(
        (impuesto: GetAllImpuestosDtoProps) => impuesto.id === value
      )?.nombre
    )
  }

  const handleConceptoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setFieldValue("concepto", value)
  }

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='tw-w-full tw-h-fit tw-flex tw-flex-col'>
        <div className='tw-flex tw-flex-col tw-mb-3'>
          <label>{t("carrito.conceptLabel")}</label>
          <InputText
            value={values.concepto}
            onChange={handleConceptoChange}
          />
        </div>
        <div className='tw-flex tw-flex-col tw-mb-3'>
          <label>{t("carrito.cantidadLabel")}</label>
          <InputNumber
            value={values.cantidad}
            onChange={({ value }: { value: number }) => {
              setFieldValue("cantidad", value)
            }}
            minFractionDigits={2}
            min={0}
            mode='decimal'
            currency={currency}
          />
        </div>
        <div className='tw-flex tw-flex-col tw-mb-3'>
          <label>{t("carrito.priceLabel")}</label>
          <InputNumber
            value={values.precioVenta}
            onValueChange={({ value }: { value: number }) => {
              setFieldValue("precioVenta", value)
            }}
            minFractionDigits={2}
            min={
              values.typeDocument === TYPES_DOCUMENTOS.FACTURA ? undefined : 0
            }
            mode='currency'
            currency={currency}
          />
        </div>
        <div className='tw-flex tw-flex-col'>
          <label>{t("carrito.typeImp")}</label>
          <DropdownPrimeReact
            options={impuestoEmpresa?.items ?? []}
            value={values.impuestoArticuloTipoId}
            onChange={handlerChangeTaxe}
            optionLabel='nombre'
            optionValue='id'
            className='tw-mb-1'
          />
          <InputNumber
            value={values.impuestoArticuloPorcentaje}
            disabled
            min={0}
            suffix='%'
          />
        </div>
      </div>

      <div className='tw-mt-4 tw-flex tw-h-10 tw-flex-row tw-justify-end tw-items-center'>
        <ButtonPrimeReact
          className='tw-mr-3 tw-h-10 tw-flex tw-justify-center hover:!tw-shadow tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer'
          onClick={onHide}
        >
          {t("crear.facturaRec.modal.cancelButton")}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          type='submit'
          disabled={!isValid}
          className='!tw-bg-primary tw-h-10 tw-flex tw-justify-center tw-items-center hover:!tw-shadow hover:!tw-bg-primary-over'
        >
          {t("crear.facturaRec.modal.addButton")}
        </ButtonPrimeReact>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  cantidad: Yup.number().min(0).required(),
  concepto: Yup.string().required(),
  impuestoArticuloPorcentaje: Yup.number().required(),
  impuestoArticuloTipoId: Yup.string().required(),
  impuestoNombre: Yup.string().required(),
  precioVenta: Yup.number().required(),
})

const FormDetalleArticuloDocument = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapPropsToValues: ({ articulo, typeDocument }: $TSMigrationFixMe) => ({
    ...articulo,
    typeDocument,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit: (values: $TSMigrationFixMe, { props }: $TSMigrationFixMe) => {
    props.onChange(values)
    props.onHide()
  },
})(DetalleArticuloDocument)

export default FormDetalleArticuloDocument
